module.exports = __webpack_public_path__ + "img/7314f3e.jpg";